import {
    RECEIVE_ACCOUNT,
    REQUEST_ACCOUNT,
    REQUEST_ACCOUNT_FAILED
} from '../../../actions/truckLoadRate/admin/accountActions';
import { TCXAccount } from '../../../../interfaces/TCXInterfaces';

interface AccountState {
    account?: TCXAccount;
    isFetchingAccount: boolean;
}

const accountInitialState: AccountState = {
    isFetchingAccount: false
};

const accountReducer = (accountState: AccountState = accountInitialState, action: any): AccountState => {
    switch (action.type) {
        case REQUEST_ACCOUNT: {
            return {
                ...accountState,
                account: undefined,
                isFetchingAccount: true
            };
        }
        case REQUEST_ACCOUNT_FAILED: {
            return {
                ...accountState,
                account: undefined,
                isFetchingAccount: false
            };
        }
        case RECEIVE_ACCOUNT: {
            return {
                ...accountState,
                account: action.payload,
                isFetchingAccount: false
            };
        }
        default:
            return accountState;
    }
};

export default accountReducer;
